import { Coffee as Coffee_kojaro } from './Coffee.kojaro';
import { Coffee as Coffee_zoomg } from './Coffee.zoomg';
import { Coffee as Coffee_zoomit } from './Coffee.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case 'kojaro':
      return Coffee_kojaro;

    case 'zoomg':
      return Coffee_zoomg;

    default:
      return Coffee_zoomit;
  }
};

export const Coffee = IconRenderer();
